import React from 'react'
import dynamic from 'next/dynamic'
import AppDrawer from '@components/Sidebar/AppDrawer'
import Navigation from '@components/organisms/Navigation'
import { Word } from '@containers/Word'
import { initializeApollo } from '@graphql/apolloClient'
import { WordsFragment, GetWordsDocument, GetWordDocument } from '@services/graphcms/client'

type Props = React.ComponentProps<typeof Word>

const DynamicFooter = dynamic(import('@components/organisms/Footer'), {
  ssr: false,
})

export default function WordPage(props: Props) {
  return (
    <>
      <AppDrawer>
        <Word word={props.word} />
        <DynamicFooter />
        <Navigation />
      </AppDrawer>
    </>
  )
}

export async function getStaticProps(context: any) {
  const apolloClient = initializeApollo()

  const { data } = await apolloClient.query({
    query: GetWordDocument,
    variables: {
      id: context.params.id as string,
    },
  })

  const nextSeoValues = {
    title: `${data?.word?.title} | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）`,
    description: `${data?.word?.content?.text}`,
    canonical: `https://coataz.com/word/${data?.word?.id}`,
    openGraph: {
      url: `https://coataz.com/word/${data?.word?.id}`,
      title: `${data?.word?.title} | 塗料業界に特化した総合情報サイトのCOATAZ（コーターズ ）`,
      description: `${data?.word?.content?.text}`,
    },
  }

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      word: data.word,
      nextSeo: nextSeoValues,
    },
    revalidate: 60,
  }
}

export async function getStaticPaths() {
  const apolloClient = initializeApollo()

  const result = await apolloClient.query({
    query: GetWordsDocument,
  })
  const paths = result.data.words.map((word: WordsFragment) => ({
    params: { id: word.id },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}
